import {Container, List, Text} from "./styled";
import {Question} from "./Question/Question";
import {Loading} from "../../CommonComponents/Loading/Loading";

// const fallbackQuestions = [
//     {question:'What does fair use policy mean?',answer:['There is standard limit to the amount of downloads. Upon request and depending on the context and purposes, these limits may be adjusted.']},
//     {question:'Can I share login details among my colleagues?',answer:['Yes, a subscription provides access to a team of professionals located in a certain location. A subscription is valid for a single office only. Login details may not be shared among offices. IP registration makes it possible to monitor usage.']},
//     {question:'Is your support 24/7?',answer:['No it is not. We are based in Amsterdam, the Netherlands and are open during standard business hours: 9.00 until 17.30 CET. Nevertheless, we try to process emails and calls outside of business hours if urgent and where possible.']},
//     {question:'To what extent does the database covers publically disclosed data?',answer:['Since 2009 PPAnalyser has started to collect purchase price allocation database and economic useful life. Through are collection process, we believe that we collect the vast majority of information disclosed. It should be noted, that the vast majority of disclosed come from annual reports that are typically published in Q1 of each year. We aim to process all annual reports in Q2 and Q3. Because of the seasonality, a certain delay in availability of data exists.','Since 2014, we have started to collect economic useful lives not directly related to PPAs and discount rates and impairment amounts that are publically disclosed. We are still in a process where we backfill the database with old data.']}
// ]

export const Questions = ({data}) => {
    const questionsList = data?.list || [];
    const questions = questionsList.length > 0
        ? questionsList.map(item => ({
            question: item.item?.title || '',
            answer: item.item?.content ? item.item.content.split('\n\n').filter(Boolean) : []
        }))
        : [];

    return (
        <Container>
            <List>
                {questions.map((question, index) => (
                    <Question key={question.question || index} title={question.question}>
                        {question.answer.map((item, answerIndex) => (
                            <Text key={answerIndex}>
                                {item}
                            </Text>
                        ))}
                    </Question>
                ))}
            </List>
        </Container>
    )
}
